import React from 'react'
import fontArray from '~/Classes/fonts'
import Icons from '~/Common-Objects/UI/Icons/index'
import Paper from '~/Common-Objects/UI/Paper/Paper'
export default function TwoColPaperExplainer({ title = '', content = '', className = '', icon = null }) {
    let finalClassName = 'mar-b16'
    if (className) finalClassName = className

    let finalStyle = {
        border: 0,
        backgroundColor: '#F7F3F0',
        width: '100%',
        padding: '16px',
        display: 'flex',
        flexDirection: 'row',
        gap: '12px',
        justifyContent: 'space-between',
        alignItems: 'center',
        fontSize: 13
    }

    if (className.indexOf('paper-') > -1) {
        delete finalStyle.backgroundColor
    }

    return (
        <Paper className={finalClassName} style={finalStyle}>
            <div style={{ flex: 0 }}>
                {icon ? (
                    icon
                ) : (
                    <Icons icon='questionCircle' color='#7A7876' style={{ width: '20px', height: '20px' }} />
                )}
            </div>
            <div style={{ flex: 1 }}>
                <div className='text-heavy' style={{ marginBottom: 2 }}>
                    {title}
                </div>
                <div className='text-grey-800'>{content}</div>
            </div>
        </Paper>
    )
}
